"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Link from "next/link";
import Tilt from "@/components/ui/ResponsiveTilt";
import { motion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import { shopifyCtaBanners, ShopifyCtaBanner } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyDualCtaBannersProps {
  banners?: ShopifyCtaBanner[];
  className?: string;
}
export default function ShopifyDualCtaBanners(t0) {
  const $ = _c(10);
  const {
    banners: t1,
    className: t2
  } = t0;
  const banners = t1 === undefined ? shopifyCtaBanners : t1;
  const className = t2 === undefined ? "" : t2;
  const desktopAnimations = useDesktopAnimations();
  const t3 = `relative overflow-hidden bg-white py-12 font-sans transition-colors duration-300 sm:py-16 lg:py-20 dark:bg-[#070b14] ${className}`;
  let t4;
  if ($[0] !== banners || $[1] !== desktopAnimations) {
    let t5;
    if ($[3] !== desktopAnimations) {
      t5 = (banner, idx) => <motion.div key={banner.id} initial={desktopAnimations ? {
        opacity: 0,
        y: 30
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.65,
        delay: idx * 0.15,
        ease
      }} className="h-full"><Tilt tiltMaxAngleX={5} tiltMaxAngleY={5} perspective={1000} transitionSpeed={1000} scale={1} tiltReverse={false} glareEnable={false} className="h-full"><article className={`group relative flex h-full min-h-[240px] flex-col items-start justify-between overflow-hidden rounded-[20px] p-8 transition-shadow duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:shadow-[0_22px_50px_rgba(0,0,0,0.22)] sm:min-h-[270px] sm:p-10 lg:p-12 ${banner.bgGradient} ${banner.shadowColor}`}><div className="pointer-events-none absolute -right-12 -top-12 h-44 w-44 rounded-full bg-white/20 blur-2xl transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:scale-125" aria-hidden="true" /><div className="pointer-events-none absolute -bottom-12 -left-12 h-44 w-44 rounded-full bg-black/10 blur-2xl transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:scale-110" aria-hidden="true" /><h3 className="relative z-10 mb-8 max-w-md font-poppins text-[21px] font-bold leading-[1.3] text-white sm:text-[23px] lg:text-[25px]">{banner.title}</h3><Link href={banner.buttonHref} className="group/btn relative z-10 inline-flex items-center gap-2 overflow-hidden rounded-full border border-white bg-white px-7 py-3.5 font-poppins text-[14.5px] font-semibold text-[#1f2137] shadow-[0_10px_15px_0_rgba(3,35,68,0.1)] transition-all duration-500 ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:-translate-y-1 hover:shadow-[0_12px_28px_rgba(0,0,0,0.22)] active:scale-95 sm:px-8 sm:py-4 sm:text-[15.5px]"><span aria-hidden={true} className="pointer-events-none absolute inset-0 z-0 bg-[linear-gradient(to_right,#ffbd84_0%,#ff1f8e_100%)] opacity-0 transition-opacity duration-500 ease-out group-hover/btn:opacity-100" /><span className="relative z-10">{banner.buttonText}</span><FaChevronRight className="relative z-10 text-[12px] transition-transform duration-300 group-hover/btn:translate-x-1" /></Link></article></Tilt></motion.div>;
      $[3] = desktopAnimations;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    t4 = banners.map(t5);
    $[0] = banners;
    $[1] = desktopAnimations;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8"><div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">{t4}</div></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <section className={t3}>{t5}</section>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}